import { CLASS_NAMES, EVENTS, SELECTORS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for handling donate box text animation functionality
 */
export default class DonateBox extends MessageBus {
  /**
   * Constructor function of the DonateBox class.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    this.element = element;

    this.init();
  }

  /**
   * Initializes the view by setting up event handlers
   * @returns {DonateBox} A reference to the current instance of the class
   */
  init() {
    this.cacheDomReferences().enable();

    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {DonateBox} A reference to the current instance of the class
   */
  cacheDomReferences() {
    this.primaryButton = this.element.querySelector(
      `.${CLASS_NAMES.BUTTON_PRIMARY}`
    );

    this.donateBoxImageBcFull = this.element.querySelector(
      `.${CLASS_NAMES.DONATE_BOX_IMAGE_BC_FULL}`
    );

    this.contentWrapper = this.element.querySelector(
      `.${CLASS_NAMES.CONTENT_WRAPPER_JS}`
    );

    return this;
  }

  /**
   * Enables event listeners for video play/pause
   * @returns {DonateBox} A reference to the current instance of the class
   */
  enable() {
    if (this.primaryButton && this.donateBoxImageBcFull) {
      const hoverImg = this.donateBoxImageBcFull.getAttribute(
        SELECTORS.DATA_HOVERIMG
      );
      const originalImg = this.donateBoxImageBcFull.style.backgroundImage;

      this.primaryButton.addEventListener(EVENTS.MOUSEENTER, () => {
        if (hoverImg) {
          this.donateBoxImageBcFull.style.backgroundImage = `url('${hoverImg}')`;
        }
      });

      this.primaryButton.addEventListener(EVENTS.MOUSELEAVE, () => {
        this.donateBoxImageBcFull.style.backgroundImage = originalImg;
      });
    }

    if (this.contentWrapper) {
      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.contentWrapper.classList.add(CLASS_NAMES.IN_VIEWPORT);
              observerInstance.unobserve(this.contentWrapper);
            }
          });
        },
        {
          root: null,
          threshold: 0.2
        }
      );

      observer.observe(this.contentWrapper);
    }

    return this;
  }
}
